<template>
  <v-row>
    <v-col cols="12" class="pb-0">
      <Title
        text-start
        :font-weight="600"
        :font-size="16"
        :title="address.addressType.name"
      />
    </v-col>

    <v-col cols="12" class="">
      <Title
        text-start
        :font-weight="600"
        :font-size="14"
        title="Поиск адреса"
      />
    </v-col>

    <v-col cols="12" class="py-0">
      <v-autocomplete
        v-model="addressGAR.country"
        :items="dictionaries.country"
        item-text="name"
        placeholder="Выберите данные"
        no-data-text="Не найдено"
        clearable
        return-object
        outlined
        rounded
        dense
        @input="saveAddress"
        @blur="$v.addressGAR.country.$touch()"
        :error-messages="$errorMessages($v.addressGAR.country)"
      >
        <template #label>
          <span class="required">Страна</span>
        </template>
      </v-autocomplete>
    </v-col>

    <v-col cols="12" class="py-0">
      <v-autocomplete
        v-model="selectedBySearchStringResponse"
        :items="searchStringResponse"
        :loading="loadingSearchString"
        :disabled="disabledSearchStringResponse"
        item-text="name"
        label="Поиск адреса"
        placeholder="Начните вводить адрес (поиск от 3-х символов)"
        no-data-text="Не найдено"
        hide-details
        hide-no-data
        hide-selected
        no-filter
        clearable
        return-object
        outlined
        rounded
        dense
        @update:search-input="getFindRefIdBySearchString($event)"
      />

      <v-autocomplete
        class="pt-6"
        v-model="selectedByHouses"
        :items="housesByObjectId"
        :loading="loading"
        :disabled="!selectedBySearchStringResponse"
        item-text="name"
        label="Дом"
        placeholder="Выберите данные"
        no-data-text="Не найдено"
        clearable
        return-object
        outlined
        rounded
        dense
      />
    </v-col>

    <v-col cols="12" class="pt-0">
      <Title
        text-start
        :font-weight="600"
        :font-size="12"
        title="Адрес"
      />
    </v-col>

    <v-col cols="12" class="py-0">
      <v-lazy>
        <v-textarea
          v-model="addressGAR.fullAddress"
          placeholder="Введите адрес"
          :disabled="!addressGAR.country"
          outlined
          rounded
          dense
          auto-grow
          rows="1"
          @input="saveAddress"
          @blur="$v.addressGAR.fullAddress.$touch()"
          :error-messages="$errorMessages($v.addressGAR.fullAddress)"
        >
          <template #label>
            <span class="required">Адрес</span>
          </template>
        </v-textarea>
      </v-lazy>
    </v-col>

    <v-col cols="6" class="py-0">
      <v-text-field
        v-model.trim="addressGAR.flat"
        placeholder="Введите данные"
        :disabled="!addressGAR.country"
        outlined
        rounded
        dense
        @input="saveAddress"
        @blur="$v.addressGAR.flat.$touch()"
        :error-messages="$errorMessages($v.addressGAR.flat)"
      >
        <template #label>
          <span class="required">Квартира</span>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="6" class="py-0">
      <v-text-field
        v-model.trim="addressGAR.postalCode"
        placeholder="Введите данные"
        :disabled="!addressGAR.country"
        outlined
        rounded
        dense
        @input="saveAddress"
        @blur="$v.addressGAR.postalCode.$touch()"
        :error-messages="$errorMessages($v.addressGAR.postalCode)"
      >
        <template #label>
          <span class="required">Индекс</span>
        </template>
      </v-text-field>
    </v-col>

<!--    <v-col cols="12" class="py-0 d-flex align-center justify-start" v-if="isView">-->
<!--      <v-checkbox-->
<!--        v-model="addressGAR.theSame"-->
<!--        class="mt-0 ml-4"-->
<!--        hide-details-->
<!--        label="Фактический адресс совпадает с адресом регистрации"-->
<!--        @change="saveAddress"-->
<!--      />-->
<!--    </v-col>-->
  </v-row>
</template>

<script>
import Title from '@/components/ui/Title'
import { AddressGar } from "@/models";
import { mapGetters } from "vuex";
import { addressSearchApi, addressGarApi } from '@/api'
import _ from 'lodash'
import {addressGar} from "@/scripts/rules-validation";

export default {
  name: "Addresses",

  components: {
    Title
  },

  props: {
    address: Object
  },

  data: () => ({
    addressGAR: new AddressGar(),

    searchStringResponse: [],
    fullAddressByRefId: [],
    housesByObjectId: [],

    selectedBySearchStringResponse: null,
    selectedByHouses: null,

    loadingSearchString: false,
    loading: false,
  }),

  validations() {
    return {
      addressGAR: { ...addressGar }
    }
  },

  computed: {
    ...mapGetters('dictionaries', ['dictionaries']),

    disabledSearchStringResponse() {
      return this.addressGAR.country?.id !== 1
    },

    isView() {
      return this.addressGAR.addressType?.id === 1
    }
  },

  methods: {
    async saveAddress() {
      if (this.addressGAR.addressCells?.length) {

        if (!this.addressGAR.id) {
          const data = await addressGarApi.create(this.addressGAR)
          this.addressGAR.setProperties(data)
        }

        this.addressGAR.addressCells.forEach(item => item.addressGAR = {id: this.addressGAR.id})
        const lvl10 = this.addressGAR.addressCells.find(item => item.level === 10)

        if (lvl10) {
          this.addressGAR.houseRef = lvl10.refId
        }
      }
      this.$emit('save-address',  this.addressGAR)
    },

    getFindRefIdBySearchString: _.debounce(async function(value) {
      try {
        if (value?.length >= 3 && !this.searchStringResponse.find(item => item.name === value)) {
          this.selectedByHouses = null
          this.loadingSearchString = true
          this.searchStringResponse = await addressSearchApi.findRefIdBySearchString(value)
        }
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.loadingSearchString = false
      }
    }, 500),

    async getFindFullAddressByRefId(refId, lvl = null) {
      try {
        const params = lvl ? `${refId}${lvl}` : refId
        this.loading = true
        return await addressSearchApi.findFullAddressByRefId(params)
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.loading = false
      }
    },

    async getFindHousesByObjectId(objectId) {
      try {
        this.loading = true
        return await addressSearchApi.findHousesByObjectId(objectId)
      } catch (e) {
        this.showErrorMessage(e)
      } finally {
        this.loading = false
      }
    },

    objectIdFromMaxLvl() {
      return this.fullAddressByRefId.addressCellList.sort((a, b) => b.level - a.level)[0].objectId
    }
  },

  watch: {
    'address': {
      immediate: true,
      deep: true,
      handler(value) {
        this.addressGAR = AddressGar.build(value)
      }
    },

    'selectedBySearchStringResponse.refId': {
      immediate: true,
      async handler(value) {
        if (value) {
          this.fullAddressByRefId = await this.getFindFullAddressByRefId(value)
          this.housesByObjectId = await this.getFindHousesByObjectId(this.objectIdFromMaxLvl())
        }
      }
    },

    'selectedByHouses.refId': {
      immediate: true,
      async handler(value) {
        if (value) {
          this.fullAddressByRefId = await this.getFindFullAddressByRefId(value, '&level=10')
          this.addressGAR.addressCells = this.fullAddressByRefId.addressCellList
          this.addressGAR.postalCode = this.fullAddressByRefId.postalCode
          this.addressGAR.fullAddress = this.fullAddressByRefId.addressText
          await this.saveAddress()
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
